import React from 'react';
import { Grid, Paper } from '@mui/material';
import SidebarToggle from '../sidebar/SidebarToggle';

export default function LayoutPanel({ children, header }) {
  return (
    <Paper
      sx={{
        overflow: 'auto'
      }}
      className="layout--panel"
      elevation={0}
      square
    >
      {header && (
        <Grid
          alignItems="center"
          className="header"
          container
          spacing={0}
          wrap="nowrap"
        >
          <Grid item xs="auto">
            <SidebarToggle />
          </Grid>

          <Grid item xs>
            {header}
          </Grid>
        </Grid>
      )}

      {children}
    </Paper>
  );
}
